import { render, staticRenderFns } from "./AcessoNegado.vue?vue&type=template&id=4719ea34"
var script = {}
import style0 from "./AcessoNegado.vue?vue&type=style&index=0&id=4719ea34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports